export const HEADER_MINIMUM_Z_INDEX = 150
export const HEADER_SUBMENU_PANEL_ANIMATION_TIME_IN_MILLISECONDS = 400
export const NAVIGATION_COLLAPSED_OFFSET = Object.freeze({
  DESKTOP: 64,
  MOBILE: 56,
})
export const OMNICHANNEL = 'omnichannel'
export const ACCOUNT_PANEL = 'accountPanel'
export const MOBILE_SUBMENU_PANEL = 'mobileSubmenuPanel'
export const HEADER_POSITION_TYPE = Object.freeze({
  FIXED: 'fixed',
  STATIC: 'static',
})
